// API Configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Content attribution: remembers which article/hub page the visitor was reading
// so lead forms can report it (captured by WhatConverts via hidden content_source field)
const CONTENT_SOURCE_KEY = "dmn_content_source";
export const setContentSource = (source) => {
  try { sessionStorage.setItem(CONTENT_SOURCE_KEY, source); } catch {}
};
export const getContentSource = () => {
  try { return sessionStorage.getItem(CONTENT_SOURCE_KEY) || ""; } catch { return ""; }
};

// Images
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_e227742f-fa2d-44b4-a974-4045826f8a41/artifacts/epvouypm_DMN%20Logo%20Final%20A%20%28Light%29%20transparent.PNG";
export const DALLAS_NIGHT = "https://images.unsplash.com/photo-1765611800420-92b96b438fa3?w=1200&h=800&fit=crop";
export const DALLAS_SKYLINE = "https://images.unsplash.com/photo-1578234467412-b0bbdb4c2283?w=1200&h=800&fit=crop";

// Video URLs (Mixkit - Free Commercial Use)
export const HERO_VIDEO_HD = "https://assets.mixkit.co/videos/41375/41375-720.mp4"; // HD Ready - smaller file
export const HERO_VIDEO_FULL_HD = "https://assets.mixkit.co/videos/41375/41375-1080.mp4"; // Full HD
export const HERO_VIDEO_POSTER = "https://assets.mixkit.co/videos/41375/41375-thumb-360-0.jpg"; // Poster image

// Icon mapping
import {
  MapPin, Target, Layout, Bot, Sparkles, FileText, Share2, Building2,
  Dumbbell, Wrench, Trees, Scale, Stethoscope, Home as HomeIcon,
  Search, MousePointerClick, Palette, Globe, Shield, Mail, Video, Phone
} from "lucide-react";

export const iconMap = {
  MapPin, Target, Layout, Bot, Sparkles, FileText, Share2, Building2,
  Dumbbell, Wrench, Trees, Scale, Stethoscope, HomeIcon,
  // kebab-case names as stored in the services DB
  "search": Search,
  "map-pin": MapPin,
  "mouse-pointer": MousePointerClick,
  "palette": Palette,
  "file-text": FileText,
  "share-2": Share2,
  "globe": Globe,
  "shield": Shield,
  "mail": Mail,
  "bot": Bot,
  "video": Video,
  "phone": Phone,
};

export const getIcon = (iconName, className = "w-8 h-8") => {
  const Icon = iconMap[iconName] || Sparkles;
  return <Icon className={className} />;
};
